<template>
   <span :id="this.idd" class="contatore-violazioni">
    {{ this.contatore }}
   </span>
</template>

<script>
export default {
    props: {
        idd: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            contatore: null
        }
    },
    methods: {
        Counter() {
            let startNumber = Date.now() /100 - 2200000000
            window.localStorage.setItem("start", startNumber)
            
            let text = parseInt((startNumber)).toLocaleString(undefined, { minimumFractionDigits: 0 })
            this.contatore = text
            const z = setInterval(() => {
                try {
                    let startNumber = Date.now() /100 - 2200000000
                    startNumber = parseInt(startNumber) + Math.floor(Math.random() * 12)
                    let text = parseInt((startNumber)).toLocaleString(undefined, { minimumFractionDigits: 0 })
                    this.contatore = text;

                    window.localStorage.setItem('start', parseInt(startNumber))
                }catch (error) {
                    
                }
            }, 1600)
        },
    },
    watch: {
        contatore(newvalue,oldvalue){
            try {
                if(oldvalue < newvalue){
                    const counterElm = document.getElementById(this.idd)
                    counterElm.classList.add('blink')
                    setTimeout(() => {
                        counterElm.classList.remove('blink')
                    }, 500)
                }
            }catch(error) {
                return false
            }
        }
    },
    mounted() {
        this.Counter()
    }
}
</script>

<style scoped>
    .contatore-violazioni {
        color: red;
        font-weight: 800;
    }
    .blink {
        transition: all 200ms ease;
        animation: blink 300ms linear;
    }
    @keyframes blink {
        50% {
            opacity: .5;
        }
    }

</style>